import _ from 'lodash'

import {
    GRANTS_TABLE_CHANGE,
    GRANTS_TABLE_CHANGE_REQUEST,
    GRANTS_TABLE_DATA_RECEIVED,
    GRANTS_TABLE_LOADING_TRUE,
    GRANTS_TABLE_LOADING_FALSE,
} from './constants'

import config from '../../../../../../../../../config'

export function grantsTableChange(module, blockKey, id, level, customData, queryParams) {
    return {
        type: GRANTS_TABLE_CHANGE,
        data: {
            module,
            blockKey,
            id,
            level,
            customData,
            queryParams,
        },
    }
}

export function grantsTableChangeRequest(module, blockKey, id, level, lang, token, queryParams) {
    return {
        type: GRANTS_TABLE_CHANGE_REQUEST(id),
        payload: {
            uri: _.get(config, `api.report.${blockKey}.block[1].uri`),
            qs: {
                ...queryParams,
                entId: id,
                lang,
                token,
                level,
            },
            uriParams: {
                entId: id,
                lang,
            },
            headers: {
                'X-Token': token,
            },
        },
    }
}

export function grantsTableDataReceived(module, id, blockKey, customData) {
    return {
        type: GRANTS_TABLE_DATA_RECEIVED,
        data: {
            module,
            id,
            blockKey,
            customData,
        },
    }
}

export function grantsTableLoadingTrue(module, id, blockKey, customData) {
    return {
        type: GRANTS_TABLE_LOADING_TRUE,
        data: {
            module,
            id,
            blockKey,
            customData,
        },
    }
}

export function grantsTableLoadingFalse(module, id, blockKey, customData) {
    return {
        type: GRANTS_TABLE_LOADING_FALSE,
        data: {
            module,
            id,
            blockKey,
            customData,
        },
    }
}
